import { render, staticRenderFns } from "./PropostaAcoes.vue?vue&type=template&id=2c2e8548"
import script from "./PropostaAcoes.vue?vue&type=script&lang=js"
export * from "./PropostaAcoes.vue?vue&type=script&lang=js"
import style0 from "./PropostaAcoes.vue?vue&type=style&index=0&id=2c2e8548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports